import moment from 'moment'
import { stages } from './routes'
import { IProgram } from './store/program/interfaces'
import Moment from 'react-moment'
import React from 'react'

const getStageInformation = (currentKey: string) => {
  const currentIndex = stages.findIndex(stage => stage.key === currentKey)
  return {
    currentIndex: currentIndex,
    previous: stages[currentIndex - 1],
    next: stages[currentIndex + 1],
  }
}

// small breakpoint for small smartphones
export const isSmallMobileQuery = { query: '(max-width: 320px)' }

// breakpoint for smartphones only
export const isMobileQuery = { query: '(max-width: 575px)' }

// medium breakpoint for small tablets or smartphones
export const isTabletOrMobileQuery = { query: '(max-width: 834px)' }

// large breakpoint for bigger tablets and desktops
export const isTabletOrSmallDesktopQuery = { query: '(max-width: 1200px)' }

// extra large breakpoint for larger desktops and above
export const isLargeDesktopOrTabletQuery = { query: '(max-width: 1366px)' }

export { getStageInformation }

export const genderSymbols: Record<string, string> = {
  w: '♀',
  m: '♂️',
  d: '⚲',
}


export const getProgramIdFromUrl = () => parseInt(window.location.pathname.split('/')[2])

export const getProgramIdentifier = () => `${window.location.hostname}_${getProgramIdFromUrl()}`

export const generateProgramDateData = (program: IProgram) => {
  const registrationStart = program.start_registration_date
  const registrationEnd = program.last_registration_date

  const registrationStartMoment =  moment(registrationStart).isValid() ? (
      <Moment format='DD.MM.Y HH:mm'>{registrationStart}</Moment>
  ) : undefined

  const registrationEndMoment =  moment(registrationEnd).isValid() ? (
    <Moment format='DD.MM.Y HH:mm'>{registrationEnd}</Moment>
  ) : undefined
  
  const afterRegistrationEnd = moment().diff(registrationEnd, 'minute')
  const afterRegistrationStart = moment().diff(registrationStart, 'minute')

  return {registrationStartMoment, registrationEndMoment, afterRegistrationEnd, afterRegistrationStart}
}

// Utility function to escape HTML entities
const escapeHtml = (text: string) => {
  const map: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, (m) => map[m]);
};


// Utility function to convert URLs in text to anchor tags
export const linkify = (text: string) => {
  if (text) {
    // Escape HTML entities first
    const escapedText = escapeHtml(text);
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return escapedText.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  } else {
    return text;
  }
};

const priceFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

export const formatPrice = (price: number): string => {
  return priceFormatter.format(price);
};

// Utility function to sanitize input values: trim and replace non-breaking spaces with normal spaces
export const sanitizeInput = (value: string | undefined | null): string => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  // Replace non-breaking spaces (U+00A0, U+202F, U+2007, etc.) with normal spaces and trim
  return value.replace(/[\u00A0\u202F\u2007\u2060\uFEFF]/g, ' ').trim();
};